/**
 * What the health bars surface reports (P2.1-T4), through the game report's `healthBars`: the pool's counts after
 * each frame, how many frames and layouts it has set so far, and, on request only, every bar held.
 */

/**
 * One bar as a browser suite reads it: `locked` is the width of its locked segment in logical pixels, 0 when none shows.
 */
export interface BarReading {
  readonly handle: number;
  readonly shown: boolean;
  readonly frame: string;
  readonly locked: number;
  readonly x: number;
  readonly y: number;
  readonly inUiLayer: boolean;
}

/**
 * The surface's report.
 */
export interface HealthBarReport {
  active: number;
  free: number;
  created: number;
  shown: number;
  frames: number;
  layouts: number;
  list: () => readonly BarReading[];
}

/**
 * A report before the surface mounts.
 *
 * @returns The report.
 */
export function createHealthBarReport(): HealthBarReport {
  return { active: 0, free: 0, created: 0, shown: 0, frames: 0, layouts: 0, list: () => [] };
}
